import React    from 'react';

export const Error404 =() => {
	

	return (
	   <div>
          <h1>La direccion de pagina que ingreso no existe en este sitio.</h1>
		  		
	   </div>
	)
}
export default Error404